module.exports = __webpack_public_path__ + "img/community.f34a832d.png";